import type { FunctionComponent, MouseEventHandler } from 'react';

import { Button } from '@trello/nachos/button';

interface NewPluginPopoverConfirmProps {
  message: string;
  confirmText: string;
  confirmStyle?: 'danger' | 'primary';
  cancelText?: string;
  onConfirm: (args: { el: HTMLButtonElement }) => Promise<void> | void;
  onCancel?: (args: { el: HTMLButtonElement }) => Promise<void> | void;
}

export const NewPluginPopoverConfirm: FunctionComponent<
  NewPluginPopoverConfirmProps
> = ({
  message,
  confirmText,
  confirmStyle = 'primary',
  cancelText,
  onConfirm,
  onCancel,
}) => {
  const handleConfirm: MouseEventHandler<HTMLButtonElement> = async (e) => {
    try {
      await onConfirm({ el: e.currentTarget });
    } catch (err) {
      console.warn(`Error running Power-Up onConfirm function: ${err}`);
    }
  };

  const handleCancel: MouseEventHandler<HTMLButtonElement> = async (e) => {
    if (onCancel) {
      try {
        await onCancel({ el: e.currentTarget });
      } catch (err) {
        console.warn(`Error running Power-Up onCancel function: ${err}`);
      }
    }
  };

  return (
    <div>
      <p>{message}</p>
      <Button
        onClick={handleConfirm}
        appearance={confirmStyle}
        size="fullwidth"
      >
        {confirmText}
      </Button>
      {cancelText && (
        <Button onClick={handleCancel} size="fullwidth">
          {cancelText}
        </Button>
      )}
    </div>
  );
};
